import React, {Component} from 'react';
import PropTypes from "prop-types";
import PageLinksContainer from "../../utils/PageLinksContainer";
import Machines from "../../utils/entities/Machines";
import ReportTile from "./ReportTile";
import ReportStitches from "./ReportStitches";
import ReportMachinePerformance from "./ReportMachinePerformance";
import ReportThreadbreaksByDesign from "./ReportThreadbreaksByDesign";
import ReportThreadbreaksByMachine from "./ReportThreadbreaksByMachine";
import ReportShiftComparison from "./ReportShiftComparison";
import ReportTimeComparison from "./ReportTimeComparison";
import ReportAverageRPM from "./ReportAverageRPM";
import ReportNumberOfPieces from "./ReportNumberOfPieces";
import ReportMachineProductivity from "./ReportMachineProductivity";
import ReportRunningtime from "./ReportRunningtime";
import ReportOperatorOverview from "./ReportOperatorOverview";
import ReportMachineSummary from "./ReportMachineSummary";
import ReportDailyDesign from "./ReportDailyDesign";
import ReportDesignSummary from "./ReportDesignSummary";

import "./Reports.css";

const reports = [
    {
        name: "threadbreaksByMachine",
        nameKey: "reportName1",
        descriptionKey: "reportDescription1",
        //image: require("../../img/dashboard/muster_colsdiagram.gif").default,
        image: require("../../img/dashboard/reports/saeulendiagramm-default.svg").default,
        component: <ReportThreadbreaksByMachine/>
    },
    {
        name: "stitches",
        nameKey: "reportName2",
        descriptionKey: "reportDescription2",
        image: require("../../img/dashboard/reports/saeulendiagramm-default.svg").default,
        component: <ReportStitches/>
    },
    {
        name: "machinePerformance",
        nameKey: "reportName3",
        descriptionKey: "reportDescription3",
        //image: require("../../img/dashboard/muster_piediagram.gif").default,
        image: require("../../img/dashboard/reports/tortendiagramm-default.svg").default,
        component: <ReportMachinePerformance/>
    },
    {
        name: "threadbreaksByDesign",
        nameKey: "reportName4",
        descriptionKey: "reportDescription4",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportThreadbreaksByDesign/>
    },
    {
        name: "shiftComparison",
        nameKey: "reportName5",
        descriptionKey: "reportDescription5",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportShiftComparison/>
    },
    {
        name: "timeComparison",
        nameKey: "reportName6",
        descriptionKey: "reportDescription6",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportTimeComparison/>
    },
    {
        name: "averageRevolutionsPerMinute",
        nameKey: "reportName7",
        descriptionKey: "reportDescription7",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportAverageRPM/>
    },
    {
        name: "numberOfPieces",
        nameKey: "reportName8",
        descriptionKey: "reportDescription8",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportNumberOfPieces/>
    },
    {
        name: "machineProductivity",
        nameKey: "reportName9",
        descriptionKey: "reportDescription9",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportMachineProductivity/>
    },
    {
        name: "runningtime",
        nameKey: "reportName10",
        descriptionKey: "reportDescription10",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportRunningtime/>
    },
    /*{
        name: "productiontime",
        nameKey: "reportName16",
        descriptionKey: "reportDescription16",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportProductiontime/>
    },*/
    {
        name: "operator",
        nameKey: "reportName11",
        descriptionKey: "reportDescription11",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportOperatorOverview/>
    },
    {
        name: "machineSummary",
        nameKey: "reportName12",
        descriptionKey: "reportDescription12",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportMachineSummary/>
    },
    {
        name: "dailyDesign",
        nameKey: "reportName13",
        descriptionKey: "reportDescription13",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportDailyDesign/>
    },
    {
        name: "designSummary",
        nameKey: "reportName14",
        descriptionKey: "reportDescription14",
        image: require("../../img/dashboard/reports/tabelle-default.svg").default,
        component: <ReportDesignSummary/>
    },
    /*{
        name: "sensors",
        nameKey: "reportName15",
        descriptionKey: "reportDescription15",
        image: require("../../img/dashboard/reports/saeulendiagramm-default.svg").default,
        component: <ReportSensorsOverview/>
    },*/
    // {
    //     name: "locationPerformance",
    //     nameKey: "reportName5",
    //     title: "Location Performance Analysis",
    //     descriptionKey: "reportDescription5",
    //     description: "Displays the total output of the factory, sorted by location.",
    //     image: require("../../img/dashboard/muster_colsdiagram.gif").default
    // }
];

class ReportContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
        activePageChanged: PropTypes.number.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {
            selectedReport: null,
            activePageChanged: -1
        };

        this.translate = this.props.baseData.translate;

        this.reportSelected = this.reportSelected.bind(this);
        this.reportUnselected = this.reportUnselected.bind(this);
        this.getSelectedReport = this.getSelectedReport.bind(this);

    };

    componentWillReceiveProps(nextProps) {

        if (nextProps.activePageChanged > this.state.activePageChanged) {
            if (this.state.activePageChanged === -1) {
                this.setState({activePageChanged: nextProps.activePageChanged});
            } else {
                this.setState({
                    selectedReport: null,
                    activePageChanged: nextProps.activePageChanged
                });
            }
        }

    }

    reportSelected(event, rpt) {

        event.preventDefault();

        this.setState({selectedReport: rpt});

    }

    reportUnselected() {

        this.setState({selectedReport: null});

    }

    getPageLinks() {

        const pageLinks = [];

        for (let i in reports) {
            let rpt = reports[i];

            pageLinks.push({
                position: parseInt(i) + 1,
                header: this.translate(rpt.nameKey),
                src: rpt.image,
                body: this.translate(rpt.descriptionKey),
                link: rpt.name,
            });
        }

        return pageLinks;

    }

    getSelectedReport() {

        if (!this.state.selectedReport) return null;

        for (let ix in reports) {
            let rpt = reports[ix];

            if (rpt.name === this.state.selectedReport) return rpt;
        }

        return null;

    }

    generateReportComponent() {

        let selected = this.getSelectedReport();

        return React.cloneElement(selected.component, {
            reportName: this.translate(selected.nameKey),
            baseData: this.props.baseData,
            machines: this.props.machines
        });

    }

    generateReportTiles() {

        return reports.map((rpt) => {
            const img = <img src={rpt.image} alt="" style={{height:172}}/>;

            return (
                <ReportTile
                    name={rpt.name}
                    key={rpt.name + 'Key'}
                    title={rpt.title}
                    description={rpt.description}
                    image={img}
                    clickHandler={this.reportSelected}
                />
            );
        });

    }

    render() {

        const selected = this.getSelectedReport();

        let title = null;
        let content = null;
        let buttons = <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('analysis')}>{this.translate('backToOverview')}</a>;

        if (selected && selected.component) {
            // Ein Report wurde ausgewählt - wird angezeigt
            title = this.translate(selected.nameKey);
            content = this.generateReportComponent();
            buttons = <a className="prewLink" onClick={(e) => this.reportUnselected()}>{this.translate('backToOverview')}</a>;
        } else {
            // Es wird die Übersicht mit den Report-Kacheln gezeigt
            const pageLinks = this.getPageLinks();

            title = this.translate('reports');

            content = (
                <div className="clearfix">
                    <PageLinksContainer
                        pageLinks={pageLinks}
                        linkClasses="report"
                        onClick={this.reportSelected}
                    />

                    {/*this.generateReportTiles()*/}
                </div>
            );
        }

        return (
            <div className="reportContainer">
                <nav>
                    <h1>{title}</h1>
                </nav>

                <div className="clearfix">
                    {content}
                </div>

                <div className="bottomLinks clearfix">
                    {buttons}
                </div>
            </div>
        );

    }

}

export default ReportContainer;